import {
  BestSellers,
  PreviewBanner,
  OurBrands,
  FeatureBanner,
} from '../../components';

const Main: React.FC = () => (
  <>
    <PreviewBanner />
    <BestSellers />
    <FeatureBanner />
    <OurBrands />
  </>
);
export default Main;
